import { store } from "@redux/store";
import { userResetState } from "@redux/reducers/";

const { dispatch } = store;

export const handleStorageEvents = (event) => {
  if(event.key === "logoutUser") {
    dispatch(userResetState());
  }
}